// extracted by mini-css-extract-plugin
export default {"menu":"AddressAddEditor_menu__vYh23","tabContent":"AddressAddEditor_tabContent__xBu1Y","wrapper":"AddressAddEditor_wrapper__wFOUR"};